module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-11.fdf50ce2.svg";